module.exports = function(hljs) {
  return {
    subLanguage: 'xml',
    contains: [
      {
        begin: '<%', end: '%>',
        subLanguage: 'vbscript'
      }
    ]
  };
};


//////////////////
// WEBPACK FOOTER
// ../~/highlight.js/lib/languages/vbscript-html.js
// module id = 1063
// module chunks = 0